// 所有地图服务地址
const testIp = '139.9.137.227:8080'
const serverIp = '182.43.245.74:54321'
export const layerServiceURL = {
  // 中国地图服务
  "china_province": {url: '/geoserver/mapBoundary/wms?', layerName: 'province'}, // 全国省区划图层
  "china_city": {url: '/geoserver/mapBoundary/wms?', layerName: 'city'}, // 全国市区划图层
  "china_county": {url: '/geoserver/mapBoundary/wms?', layerName: 'county'}, // 全国县区划图层
  "china_township": {url: '/geoserver/mapBoundary/wms?', layerName: 'township'}, // 全国乡镇区划图层
  "china_mask": {url: '/geoserver/mapBoundary/wms?', layerName: 'china_mask'}, // 全国乡镇区划图层
  "china_mask_json": {url: '/geoserver/mapBoundary/ows?', layerName: 'china_mask'}, // 全国乡镇区划图层
  // 四川省地图服务
  "sichuan_province": {url: '/geoserver/sichuanBoundary/wms?', layerName: 'sichuan_province'},
  "sichuan_city": {url: '/geoserver/sichuanBoundary/wms?', layerName: 'sichuan_city'},
  "sichuan_county": {url: '/geoserver/sichuanBoundary/wms?', layerName: 'sichuan_county'},
  "sichuan_township": {url: '/geoserver/sichuanBoundary/wms?', layerName: 'sichuan_township'},
  // 黑龙江省地图服务
  "heilongjiang_province": {url: '/geoserver/heilongjiangBoundary/wms?', layerName: 'heilongjiang_province'},
  "heilongjiang_city": {url: '/geoserver/heilongjiangBoundary/wms?', layerName: 'heilongjiang_city'},
  "heilongjiang_county": {url: '/geoserver/heilongjiangBoundary/wms?', layerName: 'heilongjiang_county'},
  "heilongjiang_township": {url: '/geoserver/heilongjiangBoundary/wms?', layerName: 'heilongjiang_township'},
  // 吉林省地图服务
  "jilin_province": {url: '/geoserver/jilinBoundary/wms?', layerName: 'jilin_province'},
  "jilin_city": {url: '/geoserver/jilinBoundary/wms?', layerName: 'jilin_city'},
  "jilin_county": {url: '/geoserver/jilinBoundary/wms?', layerName: 'jilin_county'},
  "jilin_township": {url: '/geoserver/jilinBoundary/wms?', layerName: 'jilin_township'},
  // 辽宁省地图服务
  "liaoning_province": {url: '/geoserver/liaoningBoundary/wms?', layerName: 'liaoning_province'},
  "liaoning_city": {url: '/geoserver/liaoningBoundary/wms?', layerName: 'liaoning_city'},
  "liaoning_county": {url: '/geoserver/liaoningBoundary/wms?', layerName: 'liaoning_county'},
  "liaoning_township": {url: '/geoserver/liaoningBoundary/wms?', layerName: 'liaoning_township'},
}
